import HydrantMapItemListResultModelBase from '../_generated/modelBases/hydrant-map-item-list-result-model-base';

export default class HydrantMapItemListResultModel extends HydrantMapItemListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
